import { getPolicyListAPI } from "../sevices/policyService";

export const getPolicyList = (token,query) => async (dispatch) => {
    const data = await getPolicyListAPI(token, query , dispatch);
    dispatch(data);
    return await data.payload;
};  